import React from 'react'
import Button from '../../general/Button'
import ButtonLink from '../../general/ButtonLink'
import WrapperPageSimple from './WrapperPageSimple'


const WrapperPageEdit = ({
    pageTitle, 
    id = '',
    children,
    overlay = '',
    closePagePath = false,
    canEdit = false,
    clickEdit = false
}) => {

    const editPageButton = <>
        {canEdit && clickEdit && <div className="button-edit-title-wrapper">
            {'function' === typeof clickEdit ? (
                <Button
                    className="icon button-edit button-edit-selection-title"
                    transId="section_edit_section_title"
                    onClick={clickEdit}
                />
            ) : (
                <ButtonLink
                    pathname={clickEdit}
                    className="icon button-edit button-edit-selection-title"
                    transId="section_edit_section_title"
                />
            )}
        </div>}
    </>

    return <WrapperPageSimple
        pageTitle={pageTitle}
        pageTitleTransId=''
        children={children}
        overlay={overlay}
        editPageButton={editPageButton}
        addClassName=''
        closePagePath={closePagePath}
        handleScroll={false}
        id={id}
    />
}
export default WrapperPageEdit


